import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import { toSplitGroup, type RawSplitGroup } from "../lib/split-vm";

export function useSplits() {
  return useQuery({
    queryKey: ["splits"],
    queryFn: async () => {
      const { data, error } = await apiClient.GET("/v1/split-orders");
      if (error) throw error;
      // BE may return a thinner projection than SplitDetail renders; toSplitGroup
      // defaults the nested arrays (labels/trace/items) so it can't crash.
      return (data?.data ?? []).map((s) => toSplitGroup(s as unknown as RawSplitGroup));
    },
  });
}
